import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SideBarView from './SideBar-view';

const defaultState = {};

class SideBar extends Component {
  state = defaultState;

  render() {
    return (
      <SideBarView {...this.props.user}/>
    )
  }
}

SideBar.propTypes = {
  user: PropTypes.object,
};

export default SideBar;
